import { EuiFlexGroup, EuiFlexItem,EuiFormRow } from '@elastic/eui';
import React, { useEffect, useState } from 'react';
import { ContenidoPeriodo } from '../../../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import {SelectorVersionesGiasContainer} from '../../../../../components/Selectores/VersionesGias/container';

interface Props{
    data:ContenidoPeriodo;
    periodo: number;
    ejercicio: number;
    onChange(newData:ContenidoPeriodo):void;
}

export const ContenidoVersion = (props:Props) =>{
    
    const {data, periodo, ejercicio, onChange} = props;
    const _idVersionInit = (data && data.idVersion) ? data.idVersion : undefined;
    const [contenido,setContenido] = useState<any>({idTipoContenido:data.idTipoContenido, idVersion: _idVersionInit})
    
    useEffect(()=>{
        onChange&&onChange(contenido)
    },[contenido])
    console.log('contenido ContenidoVersion ', data)
    return data.idTipoPeriodo === periodo ?
        (<EuiFlexGroup>
            <EuiFlexItem>
                <EuiFormRow fullWidth  label={data.tipoContenido}>
                    <SelectorVersionesGiasContainer 
                    ejercicio={ejercicio} 
                    valueOfSelected={contenido.idVersion}
                    onChange={(value:any)=>setContenido({idTipoContenido:data.idTipoContenido, idVersion: value})}
                    />
                </EuiFormRow>
            </EuiFlexItem>
            </EuiFlexGroup>
        )
        :null
}